import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import Loading from 'orionsoft-parts/lib/components/Loading'
import moment from 'moment'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import withOrganization from 'App/Decorators/withOrganization'
import MdSend from 'react-icons/lib/md/send'
import Actions from 'App/components/Actions'
import DraftIcon from 'react-icons/lib/md/description'
import SignersStatus from '../Common/SignersStatus'

@withOrganization
@withRouter
export default class MySignDocuments extends React.Component {
  static propTypes = {
    organization: PropTypes.object,
    router: PropTypes.object
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/documents/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {
          title: '',
          name: '_id',
          render: () => <DraftIcon size={20} />
        },
        {title: 'Nombres', name: 'name'}
      ]
    }
    return [
      {
        title: '',
        name: 'documentStatus{status}',
        render: () => <DraftIcon size={20} />
      },
      { 
        title: 'Nombre', 
        name: 'name',
        sort: 'DESC'
      },
      {
        title: 'Firmas',
        name: 'signersStatus{email, didSign}, feasStatus{email, didSign}, biosStatus{email, didSign}, faceStatus{email, didSign}' ,
        render: ({signersStatus, feasStatus, biosStatus, faceStatus}) =>
          SignersStatus(signersStatus, feasStatus, biosStatus, faceStatus)
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm'),
        defaultSort: 'DESC',
        sort: 'DESC'
      },
      {
        title: 'Tags',
        name: 'tags',
        render: ({tags}) => tags? tags.join(" ") : ""
      } /*,
      {
        title: '',
        name: '',
        render: item => this.renderActions(item)
      } */
    ]
  }


  renderActions(item) {
    return (
      <div>
        <span>
          <Actions options={this.renderOptions(item)} />
        </span>
      </div>
    )
  }

  renderAlert(item) {
    return (
      <div onClick={() => this.alert(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdSend size={20} style={{color: 'blue'}} />
            </div>
            <div className="col-xs-12 col-sm-9">Recordar firma</div>
          </div>
        </span>
      </div>
    )
  }

  renderOptions(item) {
    return [this.renderAlert(item)]
  }

  render() {
    console.log("MySignedDocuments");
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              queryName="mySignDocuments"
              defaultLimit={25}
              fields={this.getFields()}
              params="$filter: String $organization: String"
              organization={this.props.organization._id}
              onPress={this.onSelect}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/MySignDocuments/index.js